import React, { ReactNode, Suspense, useEffect, useRef } from 'react'

import { ReactiveVar, useReactiveVar } from '@apollo/client'

import ErrorBoundary from '@web/components/ErrorBoundary'
import Loading from '@web/components/Loading'

interface Props {
  children?: ReactNode
  fallback: NonNullable<ReactNode>
  renderedVar: ReactiveVar<boolean>
}

const LazyIntersectionLoader = ({ children, fallback, renderedVar }: Props) => {
  const show = useReactiveVar(renderedVar)

  const triggerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) renderedVar(true)
    })

    if (triggerRef.current) observer.observe(triggerRef.current)

    return () => observer.disconnect()
  }, [])

  if (!show) return <Loading height={200} ref={triggerRef} />

  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  )
}

export default LazyIntersectionLoader
